import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import arovyIcon from 'images/integration-logos/ArovyIcon-Blue.svg';
import azureIcon from 'images/azure-icon.svg';
import googleIcon from 'images/google-icon.svg';
import oktaIcon from 'images/okta-icon.svg';
import oneLoginIcon from 'images/onelogin-icon.svg';
import { QuestionCircleFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React, { useCallback } from 'react';
export const userIssuerTooltip = {
    azure: ADMIN_DASHBOARD_COPY.ISSUED_BY_AZURE,
    google: ADMIN_DASHBOARD_COPY.ISSUED_BY_GOOGLE,
    okta: ADMIN_DASHBOARD_COPY.ISSUED_BY_OKTA,
    onelogin: ADMIN_DASHBOARD_COPY.ISSUED_BY_ONELOGIN,
    sonar: ADMIN_DASHBOARD_COPY.ISSUED_BY_AROVY,
    unknown: ''
};
export const userIssuerIconImageSrc = {
    azure: azureIcon,
    google: googleIcon,
    okta: oktaIcon,
    onelogin: oneLoginIcon,
    sonar: arovyIcon,
    unknown: ''
};
export const UserIssuerIcon = ({ issuerType }) => {
    var _a;
    const title = (_a = userIssuerTooltip[issuerType]) !== null && _a !== void 0 ? _a : ADMIN_DASHBOARD_COPY.UNKNOWN_ISSUER;
    const iconSrc = userIssuerIconImageSrc[issuerType];
    const IssuerIcon = useCallback(() => (iconSrc ? React.createElement("img", { src: iconSrc }) : React.createElement(QuestionCircleFilled, null)), [iconSrc]);
    return (React.createElement("span", { className: 'user-issuer-icon' },
        React.createElement(Tooltip, { title: title },
            React.createElement("div", null,
                React.createElement(IssuerIcon, null)))));
};
